import { LRUCache } from './index.js'

export = Object.assign(LRUCache, { default: LRUCache, LRUCache })
